'use client';
const getName = (firstName, lastName)=>{
    if (!firstName) {
        return '';
    }
    if (!lastName) {
        return firstName;
    }
    return `${firstName} ${lastName[0]}.`;
};

export { getName };
//# sourceMappingURL=getName.js.map
